import { formatDate, isDateValue } from "./dateUtils";

export const renameColumns = (data) => {
    return data.map((item) => {
        let newItem = {};
        for (let key in item) {
            let value = item[key];
            if (key === "CO2Emission_in_grams") {
                newItem["CO2Emission_in_Mton"] = value;
            } else if (isDateValue(value)) {
                newItem[key] = formatDate(value);
            } else {
                newItem[key] = value;
            }
        }
        return newItem;
    });
};

export const cleanNumericValue = (value) => {
    if (typeof value === "number" && !isNaN(value)) {
        return Math.round(value * 100) / 100; // Round to 2 decimals
    }
    return value;
}